import React from "react"

import { PDFViewer} from '@react-pdf/renderer';

import DocumentComponent from '../PDFComponent';

const ModalPdf = (props) => {
    return (
        <div className={`modal-pdf ${props.status ? 'modal-pdf--active' : '' }`}>
            <PDFViewer>
                <DocumentComponent canvasRef={props.canvasRef} config={props.config} imgSrc={props.imgSrc}/>
            </PDFViewer>
        </div> 
    )
}

export default ModalPdf;
